import { messages } from 'AuthPart/DevicePairing/devicePairing.messages';
import { messages as authMessages } from 'AuthPart/authpart.messages';

export const DefaultError = messages['devicePairing.error.default'];

// Keys are the raw strings the identity service returns in { errors: [...] }.
export const pairingErrors = new Map([
    ['devicePairing.error.invalidCode', messages['devicePairing.error.invalidCode']],
    ['devicePairing.error.userNotFound', messages['devicePairing.error.userNotFound']],
    ['devicePairing.error.notAllowedForUser', messages['devicePairing.error.notAllowedForUser']],
    ['loginForm.error.companyRemoved', authMessages['loginForm.error.companyRemoved']],
    ['loginForm.error.trialExpired', authMessages['loginForm.error.trialExpired']],
]);

/**
 * Seat and licence refusals come back as plain English from the identity service, so anything
 * unrecognised is shown as-is rather than flattened into a useless generic message.
 */
export const readableError = (processError: string): string =>
    pairingErrors.get(processError) || processError || DefaultError;
